import React from 'react'
import { Button, Icon, Popover } from 'antd'

type EmojiCategory = {
    label: string
    icon: string
    emojis: string[]
}

type Props = {
    visible: boolean
    onVisibleChange: (visible: boolean) => void
    onSelectEmoji: (emoji: string) => void
}

type State = {
    activeCategory: string
}

const EMOJI_CATEGORIES: EmojiCategory[] = [
    {
        label: 'פרצופים',
        icon: 'smile-o',
        emojis: [
            '😀', '😁', '😂', '🤣', '😃',
            '😄', '😅', '😆', '😉', '😊',
            '🙂', '🙃', '☺️', '😇', '🥰',
            '😍', '🤩', '😘', '😗', '😚',
            '😙', '😋', '😛', '😜', '🤪',
            '😝', '🤑', '🤗', '🤭', '🤫',
            '🤔', '🫡', '🤐', '🤨', '😐',
            '😑', '😶', '🫥', '😶‍🌫️', '😏',
            '😒', '🙄', '😬', '😮‍💨', '🤥',
            '😌', '😔', '😪', '🤤', '😴',
            '😷', '🤒', '🤕', '🤢', '🤮',
            '🥵', '🥶', '🥴', '😵', '🤯',
            '😎', '🤓', '🧐', '🥳', '😤',
            '😭', '😱', '😡', '🤬', '👍'
        ]
    },
    {
        label: 'אנשים ומחוות',
        icon: 'team',
        emojis: [
            '👋', '🤚', '🖐️', '✋', '🖖',
            '👌', '🤌', '🤏', '✌️', '🤞',
            '🫰', '🤟', '🤘', '🤙', '👈',
            '👉', '👆', '🖕', '👇', '☝️',
            '🫵', '👍', '👎', '👏', '🙌',
            '👐', '🤲', '🙏', '✍️', '💅',
            '🤝', '💪', '🦾', '🫶', '🧑',
            '👨', '👩', '👶', '🧒', '👦',
            '👧', '🧑‍⚕️', '👨‍⚕️', '👩‍⚕️', '🧑‍💻',
            '👨‍💻', '👩‍💻', '🧑‍🏫', '👨‍🏫', '👩‍🏫',
            '🧑‍💼', '👨‍💼', '👩‍💼', '🧑‍🔧', '👨‍🔧',
            '👩‍🔧', '🧑‍🚀', '👨‍🚀', '👩‍🚀', '🕺',
            '💃', '🧍', '🧎', '🙋', '🙆'
        ]
    },
    {
        label: 'לבבות וסמלים',
        icon: 'heart-o',
        emojis: [
            '❤️', '🩷', '🧡', '💛', '💚',
            '🩵', '💙', '💜', '🤎', '🖤',
            '🩶', '🤍', '💔', '❣️', '💕',
            '💞', '💓', '💗', '💖', '💘',
            '💝', '💟', '☮️', '✝️', '☪️',
            '🕉️', '☸️', '✡️', '🔯', '🕎',
            '☯️', '☦️', '🛐', '⛎', '♈',
            '♉', '♊', '♋', '♌', '♍',
            '♎', '♏', '♐', '♑', '♒',
            '♓', '🆔', '⚠️', '🚫', '❌',
            '⭕', '✅', '☑️', '✔️', '💯',
            '🔥', '✨', '⭐', '🌟', '💫'
        ]
    },
    {
        label: 'חגיגה ומתנות',
        icon: 'gift',
        emojis: [
            '🎉', '🎊', '🎈', '🎁', '🎀',
            '🪄', '🎂', '🍰', '🧁', '🍫',
            '🍬', '🍭', '🍿', '🥂', '🍾',
            '🪅', '🪩', '🎆', '🎇', '🏆',
            '🥇', '🥈', '🥉', '🎖️', '🏅',
            '🎗️', '🎟️', '🎫', '🎯', '🎵',
            '🎶', '🎤', '🎧', '📣', '📢'
        ]
    },
    {
        label: 'אוכל ושתייה',
        icon: 'coffee',
        emojis: [
            '🍏', '🍎', '🍐', '🍊', '🍋',
            '🍌', '🍉', '🍇', '🍓', '🫐',
            '🍒', '🍑', '🥭', '🍍', '🥥',
            '🥝', '🍅', '🥑', '🍔', '🍟',
            '🍕', '🌭', '🥪', '🌮', '🌯',
            '🥗', '🍝', '🍣', '🍜', '🍦',
            '🍩', '🍪', '☕', '🍵', '🧃'
        ]
    },
    {
        label: 'טבע ובעלי חיים',
        icon: 'global',
        emojis: [
            '🌸', '🌹', '🌺', '🌻', '🌷',
            '🪷', '🌼', '🌿', '☘️', '🍀',
            '🌴', '🌵', '🪴', '🌳', '🌲',
            '🐶', '🐱', '🐭', '🐹', '🐰',
            '🦊', '🐻', '🐼', '🐨', '🐯',
            '🦁', '🐮', '🐷', '🐸', '🐵',
            '🐔', '🐧', '🐦', '🦄', '🦋',
            '🐝', '🐢', '🐬', '🐳', '🌍'
        ]
    },
    {
        label: 'נסיעות ומקומות',
        icon: 'car',
        emojis: [
            '🚗', '🚕', '🚌', '🚎', '🏎️',
            '🚓', '🚑', '🚒', '🚚', '✈️',
            '🛫', '🛬', '🚀', '🛸', '🚲',
            '🛴', '⛽', '🗺️', '🧭', '🏠',
            '🏡', '🏢', '🏥', '🏦', '🏫',
            '🏖️', '🏝️', '🏕️', '⛰️', '🌋',
            '🗽', '🗼', '🏰', '🌉', '🌃'
        ]
    },
    {
        label: 'חפצים וטכנולוגיה',
        icon: 'appstore-o',
        emojis: [
            '📱', '☎️', '💻', '⌨️', '🖥️',
            '🖨️', '🖱️', '💡', '🔦', '📷',
            '📹', '🎥', '📺', '📻', '⏰',
            '⌚', '🔋', '🔌', '💸', '💰',
            '💳', '🧾', '📦', '📬', '📭',
            '📅', '📆', '📝', '📌', '📎',
            '✂️', '🔒', '🔓', '🔔', '🩺',
            '💊', '🧪', '🧬', '🩹', '🧴'
        ]
    }
]

class NotificationEmojiPicker extends React.PureComponent<Props, State> {
    emojiScrollContainer: HTMLDivElement | null = null
    emojiCategoryRefs: Record<string, HTMLDivElement | null> = {}

    state: State = {
        activeCategory: 'פרצופים'
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.visible && !prevProps.visible) {
            this.setState({ activeCategory: EMOJI_CATEGORIES[0].label })
            if (this.emojiScrollContainer) {
                this.emojiScrollContainer.scrollTop = 0
            }
        }
    }

    scrollToEmojiCategory = (label: string) => {
        const container = this.emojiScrollContainer
        const target = this.emojiCategoryRefs[label]
        if (!container || !target) return

        container.scrollTo({
            top: target.offsetTop - 40,
            behavior: 'smooth'
        })

        this.setState({ activeCategory: label })
    }

    getVisibleCategories() {
        return EMOJI_CATEGORIES
    }

    handleScroll = () => {
        const container = this.emojiScrollContainer
        if (!container) return

        const categories = this.getVisibleCategories()
        const current = categories
            .filter(category => {
                const section = this.emojiCategoryRefs[category.label]
                if (!section) return false
                return section.offsetTop - 56 <= container.scrollTop
            })
            .pop()

        if (current && current.label !== this.state.activeCategory) {
            this.setState({ activeCategory: current.label })
        }
    }

    render() {
        const { visible, onVisibleChange } = this.props
        const { activeCategory } = this.state

        return (
            <Popover
                trigger="click"
                placement="bottomRight"
                overlayClassName="mediwho-app-emoji-popover"
                overlayStyle={{ width: 315 }}
                visible={visible}
                onVisibleChange={onVisibleChange}
                content={
                    <div className="mediwho-app-emoji-keyboard" style={{ direction: 'rtl', width: '100%' }}>
                        <div className="mediwho-app-emoji-categories-row">
                            {EMOJI_CATEGORIES.map(category => (
                                <button
                                    key={category.label}
                                    type="button"
                                    className={
                                        'mediwho-app-emoji-category-btn' +
                                        (activeCategory === category.label ? ' mediwho-app-emoji-category-btn-active' : '')
                                    }
                                    onClick={() => this.scrollToEmojiCategory(category.label)}
                                    title={category.label}
                                >
                                    <Icon type={category.icon} />
                                </button>
                            ))}
                        </div>
                        <div
                            ref={el => { this.emojiScrollContainer = el }}
                            className="mediwho-app-emoji-body"
                            onScroll={this.handleScroll}
                        >
                            {EMOJI_CATEGORIES.map(category => (
                                <div
                                    key={category.label}
                                    ref={el => { this.emojiCategoryRefs[category.label] = el }}
                                    className="mediwho-app-emoji-section"
                                >
                                    <div className="mediwho-app-emoji-section-title">{category.label}</div>
                                    <div className="mediwho-app-emoji-grid">
                                        {category.emojis.map(emoji => (
                                            <button
                                                key={`${category.label}-${emoji}`}
                                                type="button"
                                                className="mediwho-app-emoji-option"
                                                onClick={() => this.props.onSelectEmoji(emoji)}
                                            >
                                                {emoji}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            >
                <Button
                    size="small"
                    className="mediwho-app-emoji-trigger"
                >
                    🙂
                </Button>
            </Popover>
        )
    }
}

export default NotificationEmojiPicker
